// @flow

import React from 'react'
import { withContext } from '../../../utils/withContext'
import styles from './Mission.styl'
import { array, object } from 'prop-types'

class Mission extends React.Component {

	static propTypes = {
		features: array,
		context: object
	}

	state = { current: 0 }

	componentDidMount() {
		this.tickNextChange()
	}

	tickNextChange() {
		this.timeout = setTimeout(() => {
			const { current } = this.state
			let newCurrent = current
			if (newCurrent < 5) {
				newCurrent++
			} else {
				newCurrent = 0
			}
			this.setState({ current: newCurrent })
			this.tickNextChange()
		}, 3000)
	}

	componentWillUnmount() {
		clearTimeout(this.timeout)
	}

	scrollToElement(hash) {
		if (!hash || !window) { return }
		this.scrollElement = !this.scrollElement ? window.document.querySelector(hash) : null
		if (this.scrollElement) {
			this.scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
			this.scrollElement = null
		}
	}

	render() {
		const { current } = this.state
		const { features, context: { i18n } } = this.props

		const renderedFeatures = (features || []).map((feature, index) => (
			<li key={ index } className={ styles.list }>
				<div className={ styles.missionDiv }>
					<icon className={ styles.icon } />
					<p>{ feature.value }</p>
				</div>
			</li>
		))

		return (
			<section id="mission" className={ styles.section }>
				<div className={ styles.sectionImg } />
				<div className={ styles.sectionMask } />
				<div className={ styles['content'] }>
					<div className={ styles['title-container'] }>
						<h2>/{ i18n`mission_title_label` }</h2>
						<ul>
							<li className={ `${ styles.motos } ${ current === 0 ? 'is-active' : '' }` }>{ i18n`mission_moto_0` }</li>
							<li className={ `${ styles.motos } ${ current === 1 ? 'is-active' : '' }` }>{ i18n`mission_moto_1` }</li>
							<li className={ `${ styles.motos } ${ current === 2 ? 'is-active' : '' }` }>{ i18n`mission_moto_2` }</li>
							<li className={ `${ styles.motos } ${ current === 3 ? 'is-active' : '' }` }>{ i18n`mission_moto_3` }</li>
							<li className={ `${ styles.motos } ${ current === 4 ? 'is-active' : '' }` }>{ i18n`mission_moto_4` }</li>
							<li className={ `${ styles.motos } ${ current === 5 ? 'is-active' : '' }` }>{ i18n`mission_moto_5` }</li>
						</ul>
					</div>
					<div className={ styles['list-container'] }>
						<ul className={ styles.missionList }>
							{ renderedFeatures }
						</ul>
					</div>
					<div className={ styles.buttonDown } onClick={ () => { this.scrollToElement('#curriculum') } }>
						<div className={ styles.arrowDiv }>
							<p>/ <span>{ i18n`menu_paulo_label` }</span></p>
							<icon className={ styles.arrowIcon } />
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default withContext(Mission)



// WEBPACK FOOTER //
// ./src/client/website/components/Mission/Mission.js